import {Alert, Button, Card, CardActions, CardContent, CardHeader, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography} from "@mui/material";
import React, {useContext} from "react";
import {withAuthenticationRequired} from "@auth0/auth0-react";
import Loading from "../../components/common/Loading";
import {GlobalStateContext} from "../../state/GlobalStateProvider";
import {useTranslation} from "react-i18next";
import {useTenantConfig} from "../../security/tenant-config-context";


function CheckInHour({checkInHours, updateReservationStep, isLoadingInParent}) {
    const { t } = useTranslation();
    const {globalState, updateGlobalState} = useContext(GlobalStateContext);
    const { cfg } = useTenantConfig();

    return (
        <Card>
            <CardHeader title={<Typography color="secondary" variant="h5">{t('checkInHourTitle')}</Typography>}/>
            <CardContent>
                <TableContainer component={Paper} sx={{marginTop: 5}}>
                    <Table>
                        <TableBody>
                            {checkInHours.map((pickUpHour) => (
                                <TableRow key={pickUpHour} sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                                    <TableCell component="th" scope="row">
                                        {/* Example: Uncomment and replace {cat.name} with your cat name variable if needed */}
                                        {/* <PetsIcon color="primary" sx={{ marginRight: '10px' }} /> {cat.name} */}
                                        <Checkbox
                                            checked={pickUpHour === globalState.reservationMeta.checkInHour}
                                            onChange={() => {
                                                updateGlobalState({reservationMeta: {checkInHour: (pickUpHour === globalState.reservationMeta.checkInHour ? null : pickUpHour)}})
                                            }}
                                            name={pickUpHour.toString()}
                                            color="primary"
                                            inputProps={{ "data-testid": `check-in-hour-checkbox-${pickUpHour}` }}
                                        />
                                        <Typography variant="body1" color="secondary"><b>{pickUpHour}h</b></Typography>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        {checkInHours.length === 0 && (
                            <Alert sx={{marginTop: 2}} severity="warning" data-testid="no-check-in-hours-alert">{t('noCheckInHoursAvailable', { tenantName: cfg?.name })}</Alert>
                        )}
                    </Table>
                </TableContainer>
            </CardContent>
            <CardActions style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <>
                    <Button onClick={() => updateReservationStep(3)} variant="contained" data-testid="previous-button">
                        {t('previous')}
                    </Button>
                    {checkInHours.length !== 0 ?
                        (
                            <Button disabled={!globalState.reservationMeta.checkInHour} onClick={() => updateReservationStep(5)} variant="contained" data-testid="next-button">
                                {t('next')}
                            </Button>
                        ) : (
                            <Button onClick={() => updateReservationStep(5)} variant="contained" data-testid="next-button">
                                {t('next')}
                            </Button>)}
                </>
            </CardActions>
        </Card>
    )
}

export default withAuthenticationRequired(CheckInHour, {
    onRedirecting: () => <Loading/>,
    returnTo: '/nieuwe-reservatie'
});
